import React from 'react';
import { credentials } from '@shootsta/client-auth';
import RequestProvider from '../../RequestProvider';
import GetInTouchModalComponent from '../components/GetInTouchModal';
import { sendEmailQuery } from '../api';
import { AuthorisationConsumer } from '../../AuthorisationWrapper';










function GetInTouchModal({ product, ...props }) {
  const { userId = '' } = credentials.get().user || {};

  return (
    <AuthorisationConsumer>
      {
      ({ selectedOrganisation: { organisationId } }) =>
      <RequestProvider
        requests={{
          sendEmail: sendEmailQuery(organisationId, userId, product)
        }}>

            {(requests) =>
        <GetInTouchModalComponent
          {...props}
          {...requests} />}



          </RequestProvider>}

    </AuthorisationConsumer>);

}

export default GetInTouchModal;